import { yupResolver } from "@hookform/resolvers/yup/dist/yup";
import { useForm } from "react-hook-form";
import APIS from "../../constant/EndPoint";

//@ts-ignore
import { FormLayout } from "@careinfo/layout";
import { createRunsheetValidationForm } from "../../utils/validationSchemas";
import ComboboxInput from "../Reusable/ComboboxInput";
import TextField from "../Reusable/TextInput";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import Modal from "../Reusable/Modal";
import VehicleForm from "./VehicleForm";
import { useEffect, useState } from "react";
import DriverForm from "./DriverForm";
const CreateManifest = (props: any) => {
  const [freightValue, setFreightValue] = useState(null);
  const [advanceValue, setAdvanceValue] = useState(null);
  const [balance, setBalance] = useState(null);
  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
    setValue,
    getValues,
    clearErrors,
  } = useForm<any>({
    resolver: yupResolver(createRunsheetValidationForm),
  });
  const {
    handleCreate,
    isLoading,
    handleAddVehicle,
    isVehicleLoading,
    handleAddDriver,
    isDriverLoading,
    openAddDriverPopup,
    setOpenAddDriverPopup,
    openAddVehiclePopup,
    setOpenAddVehiclePopup,
  } = props;
  const handleFreightvalue = (event) => {
    setFreightValue(event.target.value);
  };
  const handleAdvancevalue = (event) => {
    setAdvanceValue(event.target.value);
  };
  useEffect(() => {
    let value = freightValue - advanceValue;
    setBalance(value);
  }, [freightValue, advanceValue]);

  return (
    <>
      <FormLayout
        handleSubmit={handleSubmit}
        handleFormSubmit={handleCreate}
        setError={setError}
        buttonLabel={"Submit"}
        isLoading={isLoading}
      >
        <div className={tw`mx-4`}>
          <div className={tw`grid grid-cols-3 gap-x-4 `}>
            <div className={tw`w-full flex `}>
              <div className={tw`w-full`}>
                <ComboboxInput
                  url={APIS.VEHICLE}
                  queryKey={"vehicle"}
                  register={register("vehicle")}
                  errors={errors?.vehicle}
                  name={"vehicle"}
                  label={"Vehicle Number"}
                  setValue={setValue}
                  placeholder={"Search vehicle"}
                  getValues={getValues}
                  clearErrors={clearErrors}
                />
              </div>
              <button
                className={tw`border px-4  py-2 h-10 relative top-10 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary ring-offset-1`}
                type="button"
                onClick={() => setOpenAddVehiclePopup(!openAddVehiclePopup)}
              >
                +
              </button>
            </div>

            <div className={tw`w-full flex  `}>
              <div className={tw`w-full`}>
                <ComboboxInput
                  url={APIS.DRIVER}
                  queryKey={"driver"}
                  register={register("driver")}
                  errors={errors?.driver}
                  name={"driver"}
                  label={"Driver"}
                  props={{
                    is_active: true,
                  }}
                  setValue={setValue}
                  placeholder={"Search driver"}
                  getValues={getValues}
                  clearErrors={clearErrors}
                />
              </div>
              <button
                className={tw`border px-4  py-2 h-10 relative top-10 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary ring-offset-1`}
                type="button"
                onClick={() => setOpenAddDriverPopup(!openAddDriverPopup)}
              >
                +
              </button>
            </div>
            <ComboboxInput
              url={APIS.BRANCH}
              queryKey={"branch"}
              register={register("destination_branch")}
              errors={errors?.destination_branch}
              name={"destination_branch"}
              label={"Destination"}
              props={{
                is_active: true,
              }}
              setValue={setValue}
              placeholder={"Search branch"}
              getValues={getValues}
              clearErrors={clearErrors}
            />
            <div className={tw`w-full my-2 text-left mt-4`}>
              <label htmlFor="">
                Freight
                <input
                  name={"freight"}
                  type={"number"}
                  value={freightValue}
                  {...register("freight")}
                  onChange={handleFreightvalue}
                  className={tw`w-full focus:outline-none bg-[#EEF5F4] p-2 mt-1`}
                />
              </label>
              {errors && (
                <p className={tw`text-red-500 text-xs my-1`}>
                  {errors?.message}
                </p>
              )}
            </div>
            <div className={tw`w-full my-2 text-left mt-4`}>
              <label htmlFor="">
                Advance
                <input
                  name={"advance"}
                  type={"number"}
                  value={advanceValue}
                  {...register("advance")}
                  onChange={handleAdvancevalue}
                  className={tw`w-full focus:outline-none bg-[#EEF5F4] p-2 mt-1`}
                />
              </label>
              {errors && (
                <p className={tw`text-red-500 text-xs my-1`}>
                  {errors?.message}
                </p>
              )}
            </div>
            <div className={tw`w-full my-2 text-left mt-4`}>
              <label htmlFor="">
                Balance
                <input
                  name={"balance"}
                  type={"number"}
                  value={balance}
                  disabled={true}
                  className={tw`w-full focus:outline-none bg-[#EEF5F4] p-2 mt-1`}
                />
              </label>
              {errors && (
                <p className={tw`text-red-500 text-xs my-1`}>
                  {errors?.message}
                </p>
              )}
            </div>
          </div>
          <div>
            <TextField
              label={"Note"}
              register={register(`note`)}
              errors={errors?.note}
            />
          </div>
        </div>
      </FormLayout>
      <Modal
        isOpen={openAddVehiclePopup}
        setIsOpen={setOpenAddVehiclePopup}
        title={"Add Vehicle"}
        children={
          <>
            <VehicleForm
              register={register}
              errors={errors}
              handleSubmit={handleSubmit}
              handleAddVehicle={handleAddVehicle}
              isVehicleLoading={isVehicleLoading}
            />
          </>
        }
      />
      <Modal
        isOpen={openAddDriverPopup}
        setIsOpen={setOpenAddDriverPopup}
        title={"Add Driver"}
        children={
          <>
            <DriverForm
              register={register}
              errors={errors}
              handleSubmit={handleSubmit}
              setValue={setValue}
              getValues={getValues}
              clearErrors={clearErrors}
              handleAddDriver={handleAddDriver}
              isDriverLoading={isDriverLoading}
            />
          </>
        }
      />
    </>
  );
};

export default CreateManifest;
